import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#1e355e',
    secondary: '#3f51b5',
    accent: '#607d8b',
    error: '#ff5722',
    warning: '#ff9800',
    info: '#795548',
    success: '#009688',
  },
})
